/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GiornoDellaSettimanaEnum } from './giorno-della-settimana-enum';
import { OrdinamentoScolastico } from './ordinamento-scolastico';


export interface ServizioMensaScuolaDTO { 
    id?: string;
    nome_istituto?: string;
    nome?: string;
    ordinamento?: OrdinamentoScolastico;
    indirizzo?: string;
    codice_meccanografico?: string;
    numero_minimo_pasti_da_fatturare?: number;
    has_calendario?: boolean;
    chiusure_settimanali?: Array<GiornoDellaSettimanaEnum>;
    data_inizio?: string;
    data_fine?: string;
    operatori_assegnati?: number;
}



